<template>
    <div id="page-auth-callback" data-page="auth-callback" class="auth-page-container d-flex align-items-center justify-content-center min-vh-100 py-4 py-md-5 px-3">
        <div class="auth-card p-4 px-md-5 py-md-4 rounded shadow-lg text-center" :data-state="loading ? 'loading' : (errorMessage ? 'error' : 'success')">
            <div class="mb-3 text-center">
                <div class="mb-1">
                    <router-link to="/" class="d-inline-flex align-items-center text-decoration-none">
                        <img :src="logoUrl" alt="VelocyTrack Logo" class="auth-logo mr-2" />
                        <h3 class="font-weight-bold text-white mb-0" style="font-size: 1.6rem; letter-spacing: -0.02em;">Authenticating</h3>
                    </router-link>
                </div>
                <p class="text-muted small mb-0">{{ statusMessage }}</p>
            </div>

            <div v-if="loading" class="py-4 text-center" aria-busy="true" data-test="auth-callback-loading">
                <load-spinner variant="light" size="lg" text="Verifying session..." subtext="Connecting your workspace session..." />
            </div>

            <b-alert variant="danger" :show="!!errorMessage" class="text-left small mb-4" data-test="alert-auth-callback-error">
                <div class="d-flex align-items-start">
                    <i class="bi bi-exclamation-triangle-fill mr-2 mt-1 flex-shrink-0 text-danger"></i>
                    <div>{{ errorMessage }}</div>
                </div>
            </b-alert>

            <div v-if="!loading && errorMessage" class="mt-3">
                <b-button variant="outline-light" to="/sign-in" data-test="btn-auth-callback-signin">
                    Go to Sign In
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
    import accountMixin from '../mixinAccount';

    export default {
        name: 'page-auth-callback',
        mixins: [accountMixin],
        data() {
            return {
                loading: true,
                errorMessage: '',
                statusMessage: 'Verifying your credentials...'
            };
        },
        async mounted() {
            document.documentElement.setAttribute('data-theme', 'dark');
            await this.processAuthCallback();
        },
        methods: {
            async processAuthCallback() {
                this.loading = true;
                this.errorMessage = '';
                try {
                    const resp = await this.$http.get('/Account/Me');
                    if (resp && resp.data) {
                        const provider = (this.$route.query.provider || 'GitHub').toString();
                        try {
                            localStorage.setItem(`velocytrack_last_${provider.toLowerCase()}_account`, JSON.stringify({
                                email: resp.data.email,
                                name: resp.data.fullName,
                                picture: resp.data.picture,
                                provider: provider,
                                lastLogin: new Date().toISOString()
                            }));
                        } catch (_) {
                            // Ignore localStorage errors
                        }

                        this.statusMessage = 'Setting up your cockpit session...';
                        this.$store.commit('setAccount', resp.data);
                        this.$store.commit('setAuthenticated', true);
                        await this.initSessionConfigAsync();
                        this.$router.replace('/timelog').catch(() => {});
                    } else {
                        throw new Error('Unable to retrieve account details.');
                    }
                } catch (err) {
                    this.loading = false;
                    this.errorMessage = err.response?.data?.message || err.response?.data || err.message || 'Authentication session could not be established. Please sign in again.';
                    this.statusMessage = 'Sign-in failed';
                }
            }
        }
    };
</script>

<style scoped>
    .auth-page-container {
        background-color: #030712;
        color: #f1f5f9;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    }

    .auth-card {
        background-color: #0f172a;
        border: 1px solid rgba(255, 255, 255, 0.08);
        width: 100%;
        max-width: 520px;
    }

    .auth-logo {
        height: 32px;
        width: auto;
    }
</style>
